import * as S from './styles';
import CoinImg from '../assets/coin.png';
import { useCallback, useContext } from 'react';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/utils/CalVW';
import { Mission } from '@/app/hooks/trade/tradeMission';
import BigNumber from 'bignumber.js';
import {
  getClaimStatus,
  canClaimable,
  MissionCode,
  getMissionTemplateCode,
} from '../../../utils';
import RewardButton from '../../../RewardButton';
import { DisabledRewardButton } from '../../../components/DisabledRewardButton';
import useNavigationHandler from '../../../useNavigationHandler';
import { Column } from '@/styles/reactnative';

interface DailyMissionProps {
  detailDailyMission: Mission[];
  getMissionReward: (missionId: number, tierIndex?: number, rewardAmount?: string | number) => void;
}

const DailyMission = ({
  detailDailyMission,
  getMissionReward,
}: DailyMissionProps) => {
  const { isDarkMode, theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const handleNavigation = useNavigationHandler();

  // 미션 타입에 따라 라벨과 경로 반환
  const getTargetType = useCallback(
    (mission: Mission) => {
      const targetType = mission?.conditions.targetType;

      switch (targetType) {
        case 'futures_volume':
          return {
            label: t('tradeNow'),
            path: '/trade/2',
          };
        case 'net_deposit':
          return {
            label: t('DepositNow'),
            path: '/buysell-crypto',
          };
        default:
          return {
            label: '',
            path: '',
          };
      }
    },
    [t]
  );

  return (
    <Column>
      <S.Container>
        {detailDailyMission.map((mission, index) => {
          const { label, path } = getTargetType(mission);
          const targetType = mission.conditions.targetType;

          return (
            <S.MissionCard>
              <S.MissionCardTitle>
                <S.MissionCardCoinWrapper size={isMobile ? 88 : 122}>
                  <S.MissionCardCoinImg
                    src={CoinImg}
                    size={isMobile ? 88 : 122}
                  />
                  <S.MissionCardCoinTextWrapper>
                    <S.MissionCardCoinNumber>
                      {new BigNumber(mission.rewardAmount).toFormat()}
                    </S.MissionCardCoinNumber>
                    <S.MissionCardCoinCurrency>USDT</S.MissionCardCoinCurrency>
                  </S.MissionCardCoinTextWrapper>
                </S.MissionCardCoinWrapper>

                <S.MissionCardTitleText>
                  <S.MissionCardTitleTextTitle>
                    {targetType === 'futures_volume'
                      ? t(`mission_name.DAILY_ACTIVITY_GOAL_TRADE`, {
                          defaultValue: mission.name,
                        })
                      : targetType === 'net_deposit'
                        ? t(`mission_name.DAILY_ACTIVITY_GOAL_DEPOSIT`, {
                            defaultValue: mission.name,
                          })
                        : ''}
                  </S.MissionCardTitleTextTitle>
                  <S.MissionCardTitleTextDescription>
                    {targetType === 'futures_volume'
                      ? t('dailyFuturesVolumeMissionDescription', {
                          amount: mission.conditions.targetValue,
                          defaultValue: mission.description,
                        })
                      : targetType === 'net_deposit'
                        ? t('dailyNetDepositMissionDescription', {
                            amount: mission.conditions.targetValue,
                            defaultValue: mission.description,
                          })
                        : ''}
                  </S.MissionCardTitleTextDescription>
                </S.MissionCardTitleText>
              </S.MissionCardTitle>

              <RewardButton
                missionId={mission.id}
                canClaimable={canClaimable(mission, index)}
                getMissionStatus={getClaimStatus(mission, index)}
                handleClaim={() => getMissionReward(mission.id, undefined, mission.rewardAmount)}
                style={{
                  marginTop: '6px',
                  width: '100%',
                  padding: '10px',
                  color: 'white',
                  height: isMobile ? '42px' : '46px',
                  fontSize: isMobile ? '14px' : '16px',
                }}
                notCompletedComponent={
                  <DisabledRewardButton
                    variant="orange"
                    onClick={() => handleNavigation(path)}
                    style={{ height: '46px'}}
                  >
                    {label}
                  </DisabledRewardButton>
                }
              />
            </S.MissionCard>
          );
        })}
      </S.Container>

      <S.TimezoneInfoContainer isDarkmode={isDarkMode}>
        <S.TimezoneInfoIcon>🕐</S.TimezoneInfoIcon>
        <S.TimezoneInfoContent>
          {t('daily mission timezone info')}
        </S.TimezoneInfoContent>
      </S.TimezoneInfoContainer>
    </Column>
  );
};

export default DailyMission;
